<template>
  <div class="other-cal" :class="{'other-cal--active': isDropDown}" ref="d_parent">
    <div class="other-cal__selected d-input" @click="setDropdown" v-on-clickaway="setDropdownFromClick">
      <div>{{ selectedCalendar }}</div>
      <span class="icon-menu-open"></span>
    </div>
    <ul class="other-cal__options" ref="d_child" v-if="isDropDown"
        :class="{'d-dropdown--animate': isPopperReady, 'd-dropdown--show': isPopperDone}">
      <li :class="{'item--active': selectedCalendarId === null}" @click="selectCalendar(null)">
        <span class="icon-users"></span> {{ i18n[locale]['own_calendars'] }}
      </li>
      <li
        v-for="calendar in otherCalendars"
        :key="calendar.id"
        :class="{'item--active': selectedCalendarId === calendar.id}"
        @click="selectCalendar(calendar.id)">
        <span class="icon-clipboard2"></span> {{ calendar.name }}
      </li>
    </ul>
  </div>
</template>

<script>
import DDropdown from '../common/DDropdown'
import {createPopper} from '@popperjs/core'
import {mixin as clickaway} from 'vue-clickaway'

const I18N = {
  da: {
    own_calendars: 'I hver persons kalender'
  },
  nb: {
    own_calendars: 'I hver lærers kalender'
  },
  en: {
    own_calendars: 'Each teachers calendar'
  }
}

export default {
  mixins: [clickaway],
  components: {DDropdown},
  props: {
    selectedCalendarId: {
      default: null
    },
    calendarType: {
      type: String,
      default: 'other' // 'other' | 'club'
    }
  },
  data () {
    return {
      isDropDown: false,
      isPopperReady: false,
      isPopperDone: false,
      locale: window.USER.language ? window.USER.language : 'da'
    }
  },
  computed: {
    i18n () {
      return I18N
    },
    selectedCalendar () {
      if (!this.selectedCalendarId) {
        return this.i18n[this.locale]['own_calendars']
      }
      const cal = this.otherCalendars.filter(cal => cal.id === this.selectedCalendarId)[0]
      return cal ? cal.name : this.i18n[this.locale]['own_calendars']
    },
    otherCalendars () {
      return this.calendarType === 'club' ? this.$store.getters.clubCalendars : this.$store.getters.otherCalendars
    }
  },
  methods: {
    selectCalendar (calendar) {
      this.$emit('changed', calendar)
    },
    createPopper () {
      this.isPopperReady = false
      this.isPopperDone = false
      let dChild = this.$refs.d_child
      let dParent = this.$refs.d_parent
      if (this.appendToBody) {
        document.getElementById('djs-body-click').appendChild(dChild)
      }
      createPopper(dParent, dChild, {
        placement: 'bottom-start',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -1]
            }
          }
        ]
      })
      setTimeout(_ => {
        this.isPopperReady = true
        this.isPopperDone = true
      }, 0)
    },
    setDropdown () {
      this.isDropDown = !this.isDropDown
      if (this.isDropDown) {
        setTimeout(_ => {
          this.createPopper()
        }, 0)
      } else {
        this.isPopperReady = false
        this.isPopperDone = false
      }
    },
    setDropdownFromClick () {
      if (!this.isDropDown) {
        return
      }
      this.setDropdown()
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";
.d-input {
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 5px -1px rgb(50 50 93 / 25%), 0 1px 3px -1px rgb(0 0 0 / 30%);
  border: 1px solid #edf2f7;
  min-height: 32px;
}

.other-cal--active .d-input {
  border-color: var(--blue);
  border-radius: 0;
}

.other-cal {
  position: relative;
}

.other-cal__selected {
  font-size: 12px;
  width: 100%;
  padding: 0.25rem 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.other-cal__options {
  position: absolute;
  z-index: 19990;
  top: calc(100% - 3px);
  left: 0;
  background-color: #fff;
  box-shadow: 0 3px 8px rgba(0, 0, 0, .24);
  height: auto;
  outline: none;
  text-align: left;
  padding: 0.5rem 0;
  border-radius: 0;
  min-width: 100%;
  user-select: none;
  border: 1px solid var(--blue);
  opacity: 0;
  margin-top: -10px !important;
  transition: border-color 0.25s;
}

.other-cal__options.d-dropdown--animate {
  transition: opacity 0.25s, margin-top 0.25s;
}

.other-cal__options.d-dropdown--show {
  margin-top: 0 !important;
  opacity: 1;
}

.other-cal__options li {
  padding: 0.5rem 1rem;
  cursor: pointer;
}

.other-cal__options li > span {
  margin-right: .5rem;
}

.other-cal__options li.item--active {
  color: var(--blue);
  font-weight: bold;
}

.other-cal__options li:hover {
  background-color: var(--blue);
  color: #ffffff;
}

</style>



// WEBPACK FOOTER //
// SubjectsDistributionTasksCreateDropdown.vue?6abc61cc